import config from './config.js'

export default config